import {
  SET_TABLE,
  SET_ERRORS,
  SET_FROM_LOGIN,
  SET_MENU,
  SW_INIT,
  SW_UPDATE,
  SET_TRIGGER_TABLE,
  SET_MINI_MENU,
} from "./type";

let appState = {
  menu: [],
  table: [],
  errors: null,
  miniMenu: false,
  fromLogin: false,
  serviceWorkerUpdated: false,
  serviceWorkerInitialized: false,
  serviceWorkerRegistration: null,
  triggerTable: false,
};

const appReducers = (state = appState, action) => {
  switch (action.type) {
    case SET_MENU:
      return { ...state, menu: action.payload };
    case SW_INIT:
      return {
        ...state,
        serviceWorkerInitialized: !state.serviceWorkerInitialized,
      };
    case SW_UPDATE:
      return {
        ...state,
        serviceWorkerUpdated: !state.serviceWorkerUpdated,
        serviceWorkerRegistration: action.payload,
      };
    case SET_ERRORS:
      return { ...state, errors: action.payload };
    case SET_TRIGGER_TABLE:
      return { ...state, triggerTable: action.payload };
    case SET_FROM_LOGIN:
      return { ...state, fromLogin: action.payload };
    case SET_MINI_MENU:
      return { ...state, miniMenu: action.payload };
    case SET_TABLE:
      return { ...state, table: action.payload };
    default:
      return state;
  }
};

export default appReducers;
